import { ROUTES } from 'shared/constants/routes';

export interface ArenaNavItem {
  id: string;
  label: string;
  badge?: number;
  path?: string;
}

export const ARENA_NAV_ITEMS: ArenaNavItem[] = [
  { id: 'agenda', label: 'Agenda', path: ROUTES.ARENA_DASHBOARD },
  { id: 'reservas', label: 'Reservas', badge: 2, path: ROUTES.ARENA_RESERVATIONS },
  { id: 'aulas', label: 'Aulas e turmas', path: ROUTES.ARENA_CLASSES },
  { id: 'assinaturas', label: 'Assinaturas', path: ROUTES.ARENA_SUBSCRIPTIONS },
  { id: 'torneios', label: 'Torneios', path: ROUTES.ARENA_TOURNAMENTS },
  { id: 'mural', label: 'Mural', path: ROUTES.ARENA_MURAL },
  { id: 'financeiro', label: 'Relatórios', path: ROUTES.ARENA_REPORTS },
  { id: 'quadras', label: 'Quadras e equipe', path: ROUTES.ARENA_SETTINGS },
];

export const ARENA_KPIS = [
  { label: 'Ocupação hoje', value: '78%' },
  { label: 'Receita do dia', value: 'R$ 3.640' },
  { label: 'Cotas pendentes', value: '2' },
  { label: 'Assinaturas ativas', value: '64' },
  { label: 'Renovações 05/10', value: 'R$ 16,2k' },
];

export type AgendaEventStatus = 'paid' | 'pending' | 'blocked' | 'class' | 'free';

export interface AgendaEvent {
  court: string;
  time: string;
  label: string;
  meta: string;
  status: AgendaEventStatus;
}

export const AGENDA_COURTS = ['Areia 1', 'Areia 2', 'Areia 3', 'Quadra 5'];
export const AGENDA_TIMES = ['16:00', '17:00', '18:00', '19:00', '20:00', '21:00'];

export const AGENDA_EVENTS: AgendaEvent[] = [
  { court: 'Areia 1', time: '16:00', label: 'Aula Turma A', meta: 'Camila · 6/6', status: 'class' },
  { court: 'Areia 1', time: '18:00', label: 'Manutenção', meta: 'Bloqueio de quadra', status: 'blocked' },
  { court: 'Areia 1', time: '20:00', label: 'Reserva · Ana P.', meta: 'pago · Pix', status: 'paid' },
  { court: 'Areia 2', time: '17:00', label: 'Racha nível B', meta: 'Marina L. · 3/4 cotas', status: 'pending' },
  { court: 'Areia 2', time: '18:00', label: 'Aula Turma B', meta: 'Camila · 5/6', status: 'class' },
  { court: 'Areia 3', time: '16:00', label: 'Reserva · Diego C.', meta: 'pago · cartão', status: 'paid' },
  { court: 'Areia 3', time: '17:00', label: 'Pendente · 2/4 cotas', meta: 'expira 19:42', status: 'pending' },
  { court: 'Areia 3', time: '18:00', label: 'Reserva · Léo S.', meta: 'pago · Pix', status: 'paid' },
  { court: 'Areia 3', time: '19:00', label: 'Open Praia Norte', meta: 'treino de chaves', status: 'class' },
  { court: 'Areia 3', time: '21:00', label: 'Aula avulsa', meta: 'Prof. Rui · 3/4', status: 'class' },
  { court: 'Quadra 5', time: '16:00', label: 'Pickleball livre', meta: 'uso aberto', status: 'free' },
  { court: 'Quadra 5', time: '18:00', label: 'Reserva · Bia R.', meta: 'pago · cartão', status: 'paid' },
];

export const SELECTED_ORDER = {
  id: '#10428',
  courtLabel: 'Areia 3 · 18:00',
  expiresLabel: 'Aguardando cotas · expira 19:42',
  quotas: [
    { name: 'Rafael N.', methodLabel: 'Pix', status: 'paid' as const },
    { name: 'Júlia C.', methodLabel: 'Cartão', status: 'paid' as const },
    { name: 'Diego C.', methodLabel: 'Pix', status: 'pending' as const },
    { name: 'Vaga 4', methodLabel: 'sem convite', status: 'empty' as const },
  ],
};

export const OPERATIONAL_QUEUE = [
  { title: 'Estorno automático · #10391', meta: 'reserva expirada · R$ 41,60' },
  { title: 'Lista de espera · Masculina B', meta: '3 duplas aguardando vaga' },
  { title: 'Renovação de assinatura', meta: '64 cobranças agendadas 05/10' },
  { title: 'Denúncia no mural', meta: '1 post em moderação' },
  { title: 'Conciliação de webhooks', meta: 'todos os eventos processados' },
];
